"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdditionalProperties = _interopRequireDefault(require("./AdditionalProperties"));
var _EdelmetallStufenKondition = _interopRequireDefault(require("./EdelmetallStufenKondition"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallProduktStufen model module.
 * @module model/EdelmetallProduktStufen
 * @version 1.0.44
 */
var EdelmetallProduktStufen = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallProduktStufen</code>.
   * 
   * @alias module:model/EdelmetallProduktStufen
   * @param listeStufenKonditionen {Array.<module:model/EdelmetallStufenKondition>} 
   */
  function EdelmetallProduktStufen(listeStufenKonditionen) {
    _classCallCheck(this, EdelmetallProduktStufen);
    EdelmetallProduktStufen.initialize(this, listeStufenKonditionen);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallProduktStufen, null, [{
    key: "initialize",
    value: function initialize(obj, listeStufenKonditionen) {
      obj['listeStufenKonditionen'] = listeStufenKonditionen;
    }

    /**
     * Constructs a <code>EdelmetallProduktStufen</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallProduktStufen} obj Optional instance to populate.
     * @return {module:model/EdelmetallProduktStufen} The populated <code>EdelmetallProduktStufen</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallProduktStufen();
        if (data.hasOwnProperty('listeStufenKonditionen')) {
          obj['listeStufenKonditionen'] = _ApiClient.default.convertToType(data['listeStufenKonditionen'], [_EdelmetallStufenKondition.default]);
        }
        if (data.hasOwnProperty('additionalProperties')) {
          obj['additionalProperties'] = _AdditionalProperties.default.constructFromObject(data['additionalProperties']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallProduktStufen</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallProduktStufen</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(EdelmetallProduktStufen.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['listeStufenKonditionen']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['listeStufenKonditionen'])) {
          throw new Error("Expected the field `listeStufenKonditionen` to be an array in the JSON data but got " + data['listeStufenKonditionen']);
        }
        // validate the optional field `listeStufenKonditionen` (array)
        var _iterator2 = _createForOfIteratorHelper(data['listeStufenKonditionen']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _EdelmetallStufenKondition.default.validateJSON(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      // validate the optional field `additionalProperties`
      if (data['additionalProperties']) {
        // data not null
        _AdditionalProperties.default.validateJSON(data['additionalProperties']);
      }
      return true;
    }
  }]);
}();
EdelmetallProduktStufen.RequiredProperties = ["listeStufenKonditionen"];

/**
 * @member {Array.<module:model/EdelmetallStufenKondition>} listeStufenKonditionen
 */
EdelmetallProduktStufen.prototype['listeStufenKonditionen'] = undefined;

/**
 * @member {module:model/AdditionalProperties} additionalProperties
 */
EdelmetallProduktStufen.prototype['additionalProperties'] = undefined;
var _default = exports.default = EdelmetallProduktStufen;